import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	link: {
		id: 'ai-related-issues.related-issues-draft-list.link',
		defaultMessage: 'Link',
		description: 'Text for button used to link related issue',
	},
	selectAll: {
		id: 'ai-related-issues.related-issues-draft-list.select-all',
		defaultMessage: 'Select all',
		description: 'Text for checkbox used to select all the ai provided suggestions',
	},
	deselectAll: {
		id: 'ai-related-issues.related-issues-draft-list.deselect-all',
		defaultMessage: 'Deselect all',
		description: 'Text for checkbox used to deselect all the ai provided suggestions',
	},
});
